var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import APIIN from "@/utils/APIIN";
import { call, put, takeLatest } from "redux-saga/effects";
import { GET_REMITTANCE_PAYOUT_CYCLE_REQUEST, getRemittancePayoutCycleFailure, getRemittancePayoutCycleSuccess } from "../../actions";
const onGetRemittancePayoutCycle = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        console.log("Fetching active plan data for tenantId:", action.payload.tenantId);
        try {
            APIIN.getCompany(`/company/admin/billing?tenantId=${action.payload.tenantId}`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchRemittancePayoutCycleWorker(action) {
    try {
        const data = yield call(onGetRemittancePayoutCycle, action);
        yield put(getRemittancePayoutCycleSuccess(data));
    }
    catch (error) {
        yield put(getRemittancePayoutCycleFailure(error));
    }
}
export function* watchGetRemittancePayoutCycle() {
    yield takeLatest(GET_REMITTANCE_PAYOUT_CYCLE_REQUEST, fetchRemittancePayoutCycleWorker);
}
